// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type UserProfilePageDetailAsAdminQueryVariables = PrivateSchemaTypes.Exact<{
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type UserProfilePageDetailAsAdminQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { user?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.UserModelAsAdminQueries, 'id' | 'image_url' | 'display_name' | 'email' | 'first_name' | 'last_name' | 'account_name' | 'organisation_id' | 'deleted_at' | 'position' | 'verified' | 'timezone' | 'password_last_updated_at' | 'organisation_role' | 'employee_id' | 'area' | 'location' | 'department' | 'manager_id' | 'custom_1' | 'custom_2' | 'custom_3' | 'phone_number' | 'locale'>
      & { manager?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
      )>, preferences: (
        { __typename?: 'UserPreferences' }
        & Pick<PrivateSchemaTypes.UserPreferences, 'sendCommentSummaryEmails' | 'highContrast'>
      ), scimResource?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'ScimResourceModel' }
        & Pick<PrivateSchemaTypes.ScimResourceModel, 'id' | 'external_id'>
      )> }
    )> }
  )> }
);

export type UserProfilePageDetailAsMeQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type UserProfilePageDetailAsMeQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'UserModelSelf' }
    & UserProfilePageDetailAsMeFragment
  ) }
);

export type UserProfilePageDetailAsMeFragment = (
  { __typename?: 'UserModelSelf' }
  & Pick<PrivateSchemaTypes.UserModelSelf, 'id' | 'image_url' | 'display_name' | 'email' | 'first_name' | 'last_name' | 'account_name' | 'organisation_id' | 'deleted_at' | 'position' | 'verified' | 'timezone' | 'password_last_updated_at' | 'organisation_role' | 'employee_id' | 'area' | 'location' | 'department' | 'manager_id' | 'custom_1' | 'custom_2' | 'custom_3' | 'phone_number' | 'locale'>
  & { manager?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
  )>, preferences: (
    { __typename?: 'UserPreferences' }
    & Pick<PrivateSchemaTypes.UserPreferences, 'sendCommentSummaryEmails' | 'highContrast'>
  ), scimResource?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'ScimResourceModel' }
    & Pick<PrivateSchemaTypes.ScimResourceModel, 'id' | 'external_id'>
  )> }
);

export type UserPatchAsAdminMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.UserModelBaseInput;
}>;


export type UserPatchAsAdminMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { user?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.UserModelAsAdminMutations, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserModelBase' }
        & Pick<PrivateSchemaTypes.UserModelBase, 'id' | 'display_name' | 'account_name' | 'first_name' | 'last_name' | 'position' | 'employee_id' | 'image_url' | 'email' | 'verified' | 'area' | 'timezone' | 'location' | 'department' | 'manager_id' | 'custom_1' | 'custom_2' | 'custom_3' | 'phone_number' | 'locale'>
      )> }
    )> }
  )> }
);

export type UserPatchAsSelfMutationVariables = PrivateSchemaTypes.Exact<{
  input: PrivateSchemaTypes.UserModelBaseInput;
}>;


export type UserPatchAsSelfMutation = (
  { __typename?: 'Mutation' }
  & { me: (
    { __typename?: 'UserModelSelfMutation' }
    & { patch?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelSelfMutation' }
      & Pick<PrivateSchemaTypes.UserModelSelfMutation, 'id' | 'display_name' | 'account_name' | 'first_name' | 'last_name' | 'position' | 'employee_id' | 'image_url' | 'verified' | 'area' | 'timezone' | 'location' | 'department' | 'manager_id' | 'custom_1' | 'custom_3' | 'phone_number' | 'locale'>
    )> }
  ) }
);

export type OrganisationDetailsQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type OrganisationDetailsQuery = (
  { __typename?: 'Query' }
  & { organisation: (
    { __typename?: 'OrganisationModelGQLBase' }
    & Pick<PrivateSchemaTypes.OrganisationModelGqlBase, 'can_students_update_profile'>
  ), me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'organisation_role'>
  ) }
);

export const UserProfilePageDetailAsMeFragmentDoc = gql`
    fragment UserProfilePageDetailAsMe on UserModelSelf {
  id
  image_url
  display_name
  email
  first_name
  last_name
  account_name
  organisation_id
  deleted_at
  position
  verified
  timezone
  password_last_updated_at
  organisation_role
  employee_id
  area
  location
  department
  manager {
    id
    display_name
  }
  manager_id
  custom_1
  custom_2
  custom_3
  preferences {
    sendCommentSummaryEmails
    highContrast
  }
  phone_number
  scimResource {
    id
    external_id
  }
  locale
}
    `;
export const UserProfilePageDetailAsAdminDocument = gql`
    query UserProfilePageDetailAsAdmin($userId: PositiveInt!) {
  admin {
    user(id: $userId) {
      id
      image_url
      display_name
      email
      first_name
      last_name
      account_name
      organisation_id
      deleted_at
      position
      verified
      timezone
      password_last_updated_at
      organisation_role
      employee_id
      area
      location
      department
      manager {
        id
        display_name
      }
      manager_id
      custom_1
      custom_2
      custom_3
      preferences {
        sendCommentSummaryEmails
        highContrast
      }
      phone_number
      scimResource {
        id
        external_id
      }
      locale
    }
  }
}
    `;

/**
 * __useUserProfilePageDetailAsAdminQuery__
 *
 * To run a query within a React component, call `useUserProfilePageDetailAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfilePageDetailAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfilePageDetailAsAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfilePageDetailAsAdminQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfilePageDetailAsAdminQuery, UserProfilePageDetailAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfilePageDetailAsAdminQuery, UserProfilePageDetailAsAdminQueryVariables>(UserProfilePageDetailAsAdminDocument, options);
      }
export function useUserProfilePageDetailAsAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfilePageDetailAsAdminQuery, UserProfilePageDetailAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfilePageDetailAsAdminQuery, UserProfilePageDetailAsAdminQueryVariables>(UserProfilePageDetailAsAdminDocument, options);
        }
export type UserProfilePageDetailAsAdminQueryHookResult = ReturnType<typeof useUserProfilePageDetailAsAdminQuery>;
export type UserProfilePageDetailAsAdminLazyQueryHookResult = ReturnType<typeof useUserProfilePageDetailAsAdminLazyQuery>;
export type UserProfilePageDetailAsAdminQueryResult = Apollo.QueryResult<UserProfilePageDetailAsAdminQuery, UserProfilePageDetailAsAdminQueryVariables>;
export const UserProfilePageDetailAsMeDocument = gql`
    query UserProfilePageDetailAsMe {
  me {
    ...UserProfilePageDetailAsMe
  }
}
    ${UserProfilePageDetailAsMeFragmentDoc}`;

/**
 * __useUserProfilePageDetailAsMeQuery__
 *
 * To run a query within a React component, call `useUserProfilePageDetailAsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfilePageDetailAsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfilePageDetailAsMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfilePageDetailAsMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserProfilePageDetailAsMeQuery, UserProfilePageDetailAsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfilePageDetailAsMeQuery, UserProfilePageDetailAsMeQueryVariables>(UserProfilePageDetailAsMeDocument, options);
      }
export function useUserProfilePageDetailAsMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfilePageDetailAsMeQuery, UserProfilePageDetailAsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfilePageDetailAsMeQuery, UserProfilePageDetailAsMeQueryVariables>(UserProfilePageDetailAsMeDocument, options);
        }
export type UserProfilePageDetailAsMeQueryHookResult = ReturnType<typeof useUserProfilePageDetailAsMeQuery>;
export type UserProfilePageDetailAsMeLazyQueryHookResult = ReturnType<typeof useUserProfilePageDetailAsMeLazyQuery>;
export type UserProfilePageDetailAsMeQueryResult = Apollo.QueryResult<UserProfilePageDetailAsMeQuery, UserProfilePageDetailAsMeQueryVariables>;
export const UserPatchAsAdminDocument = gql`
    mutation userPatchAsAdmin($id: PositiveInt!, $input: UserModelBaseInput!) {
  admin {
    user(id: $id) {
      id
      patch(input: $input) {
        id
        display_name
        account_name
        first_name
        last_name
        position
        employee_id
        image_url
        email
        verified
        area
        timezone
        location
        department
        manager_id
        custom_1
        custom_2
        custom_3
        phone_number
        locale
      }
    }
  }
}
    `;
export type UserPatchAsAdminMutationFn = Apollo.MutationFunction<UserPatchAsAdminMutation, UserPatchAsAdminMutationVariables>;

/**
 * __useUserPatchAsAdminMutation__
 *
 * To run a mutation, you first call `useUserPatchAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPatchAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPatchAsAdminMutation, { data, loading, error }] = useUserPatchAsAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserPatchAsAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserPatchAsAdminMutation, UserPatchAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserPatchAsAdminMutation, UserPatchAsAdminMutationVariables>(UserPatchAsAdminDocument, options);
      }
export type UserPatchAsAdminMutationHookResult = ReturnType<typeof useUserPatchAsAdminMutation>;
export type UserPatchAsAdminMutationResult = Apollo.MutationResult<UserPatchAsAdminMutation>;
export type UserPatchAsAdminMutationOptions = Apollo.BaseMutationOptions<UserPatchAsAdminMutation, UserPatchAsAdminMutationVariables>;
export const UserPatchAsSelfDocument = gql`
    mutation userPatchAsSelf($input: UserModelBaseInput!) {
  me {
    patch(input: $input) {
      id
      display_name
      account_name
      first_name
      last_name
      position
      employee_id
      image_url
      verified
      area
      timezone
      location
      department
      manager_id
      custom_1
      custom_3
      phone_number
      locale
    }
  }
}
    `;
export type UserPatchAsSelfMutationFn = Apollo.MutationFunction<UserPatchAsSelfMutation, UserPatchAsSelfMutationVariables>;

/**
 * __useUserPatchAsSelfMutation__
 *
 * To run a mutation, you first call `useUserPatchAsSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPatchAsSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPatchAsSelfMutation, { data, loading, error }] = useUserPatchAsSelfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserPatchAsSelfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserPatchAsSelfMutation, UserPatchAsSelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserPatchAsSelfMutation, UserPatchAsSelfMutationVariables>(UserPatchAsSelfDocument, options);
      }
export type UserPatchAsSelfMutationHookResult = ReturnType<typeof useUserPatchAsSelfMutation>;
export type UserPatchAsSelfMutationResult = Apollo.MutationResult<UserPatchAsSelfMutation>;
export type UserPatchAsSelfMutationOptions = Apollo.BaseMutationOptions<UserPatchAsSelfMutation, UserPatchAsSelfMutationVariables>;
export const OrganisationDetailsDocument = gql`
    query OrganisationDetails {
  organisation {
    can_students_update_profile
  }
  me {
    organisation_role
  }
}
    `;

/**
 * __useOrganisationDetailsQuery__
 *
 * To run a query within a React component, call `useOrganisationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganisationDetailsQuery, OrganisationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationDetailsQuery, OrganisationDetailsQueryVariables>(OrganisationDetailsDocument, options);
      }
export function useOrganisationDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationDetailsQuery, OrganisationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationDetailsQuery, OrganisationDetailsQueryVariables>(OrganisationDetailsDocument, options);
        }
export type OrganisationDetailsQueryHookResult = ReturnType<typeof useOrganisationDetailsQuery>;
export type OrganisationDetailsLazyQueryHookResult = ReturnType<typeof useOrganisationDetailsLazyQuery>;
export type OrganisationDetailsQueryResult = Apollo.QueryResult<OrganisationDetailsQuery, OrganisationDetailsQueryVariables>;